import React, { Fragment } from 'react'
import MainContent from './MainContent'
import WelcomeHero from './WelcomeHero'
import { Box } from '../generic/Box'

const Home = props => {
  return (
    <Fragment>
      <WelcomeHero />
      <MainContent>
        <Box>
          Home
        </Box>
      </MainContent>
    </Fragment>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/components/dashboard/Home.js